import React, { Component } from "react";
import { Input, Select } from "../../../Input";
import language from "../../../../language";
import { connect } from "react-redux";
import { Separator } from "../../../Separator";
import { getStorage } from "../../../../utils/storage";
import toastMessage from "../../../../utils/toastMessage";
import {
  fetchRequestedProducts,
// eslint-disable-next-line no-unused-vars
} from "../../../../utils/queries/request-product";
import api from "../../../../utils/api";
import { Button } from "../../../Button";
import {
  generateRandomNumber,
  generateRandomString,
} from "../../../../utils/random";

class ForwardRequest extends Component {
  state = {
    error: {},
    donationNumber: "",
    product: "",
    user: {},
    products: [],
    inventoryInfo: {},
    selectedData: {},
    requestedProducts: [],
    bulkRequestNo: "",
    selectedTo: null,
  };

  componentDidMount = async () => {
    console.log("User info >>>>>", this.props);
    const user = await getStorage();

    let bulkRequestNo =
      generateRandomString(4).toUpperCase() +
      "-" +
      generateRandomNumber(0, 1000000);

    this.setState({ user, bulkRequestNo });

    if (this.props.requestId) {
      this.getProducts(true);
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.sampleCollected !== this.props.sampleCollected) {
      this.setState({ sampleCollected: this.props.sampleCollected });
    }
  }

  getProducts = async (isLoading) => {
    try {
      this.setState({ isLoading });

      const { defaultLanguage, requestId } = this.props;

      const { data } = await fetchRequestedProducts(defaultLanguage, {
        page: 1,
        limit: 50,
        request: requestId,
      });

      let products = data?.map((el) => {
        return {
          numberOfPackages: el.numberOfPackages,
          bloodGroup: el?.request?.sampleBloodGroup,
          diagnosis: el.diagnosis,
          otherDiagnosis: el.otherDiagnosis,
          volume: el.volume,
          ...el.productType,
          label: el.productType.name,
          value: el.productType._id,
        };
      });

      this.setState({
        isLoading: false,
        products,
        requestedProducts: products,
      });
    } catch (error) {
      this.setState({
        isLoading: false,
      });
      toastMessage("error", error);
    }
  };

  onChangeText = (field, e) => {
    let { error } = this.state;

    let inputValue = e && e?.target ? e.target.value : e;

    delete error[field];
    delete error["errorMessage"];

    this.setState({ error: error, [field]: inputValue });
  };

  validateForm() {
    let { error } = this.state;
    const { requestId, requestedProducts, multipleAllowedBloodBanks } = this.props;

    if (requestId === "") {
      error.errorMessage = "Request is missing";
    }

    if (requestedProducts?.length === 0) {
      error.requestedProducts =
        language[this.props.defaultLanguage].product_required;
    }

    if (multipleAllowedBloodBanks?.length > 1 && !this.state.selectedTo) {
      error.selectedTo = language[this.props.defaultLanguage].required || "Destination is required";
    }

    this.setState({ error });
  }

  onSubmit = async (e) => {
    e.preventDefault();
    try {
      await this.validateForm();

      if (Object.keys(this.state.error).length > 0) return;

      this.setState({ isSubmitting: true });

      let { from, requestId } = this.props,
        to = this.state.selectedTo || this.props.to,
        { requestedProducts } = this.state,
        user = await getStorage(),
        url = `${process.env.REACT_APP_BBMS_BASE_API}/bloodrequest`,
        method = "POST";

      let bulkBody = {
        requestNo: this.state.bulkRequestNo,
        hospital: from?._id || from,
        bloodBank: to?._id || to,
        account: user.id,
        type: "bulk",
        requestingDoctorName: this.props.requestedByAccount?.name || this.props.requestingDoctorName,
        requestingDoctorContacts: this.props.requestedByAccount?.phone || this.props.requestingDoctorContacts,
        requestingDoctorEmail: this.props.requestedByAccount?.email || this.props.requestingDoctorEmail,
      };

      const { data } = await api({
        method,
        url,
        data: bulkBody,
      });

      let requiredBody = {};
      console.log({ requestedProducts });

      for (let [i, el] of requestedProducts.entries()) {
        requiredBody = {
          type: "bulk",
          request: data._id,
          productType: el.value,
          numberOfPackages: el.numberOfPackages,
          bloodGroup: el.bloodGroup,
          diagnosis: el.diagnosis,
          otherDiagnosis: el.otherDiagnosis,
          volume: el.volume,
          forwadedRequest: requestId,
        };

        const options = {
          method,
          url: `${process.env.REACT_APP_BBMS_BASE_API}/product-request`,
          data: requiredBody,
        };

        await api(options);

        if (i === requestedProducts.length - 1) {
          this.setState({ isSubmitting: false });
          this.props.handleCloseModal();
          this.props.getData(true);
        }
      }
    } catch (error) {
      this.setState({ isSubmitting: false });
      console.log(error);

      return {
        failed: true,
        success: false,
        error: error?.response?.data?.error,
      };
    }
  };

  render() {
    return (
      <div>
        <div className="card-body">
          {this.state.errorMessage && (
            <div className="alert alert-danger mb-3">
              {this.state.errorMessage}
            </div>
          )}
          <div className="row">
            <div className="col-md-6">
              <Input
                label={language[this.props.defaultLanguage].nominative_number}
                value={this.props.requestNo}
                disabled
              />
            </div>
            <div className="col-md-6">
              <Input
                label={language[this.props.defaultLanguage].bulk_number}
                value={this.state.bulkRequestNo}
                disabled
              />
            </div>
            <div className="col-md-6">
              <Input
                label={language[this.props.defaultLanguage].source}
                value={this.props?.from?.name || this.props?.from}
                disabled
              />
            </div>
            <div className="col-md-6">
              {this.props.multipleAllowedBloodBanks?.length > 1 ? (
                <Select
                  label={language[this.props.defaultLanguage].destination}
                  options={this.props.multipleAllowedBloodBanks.map((bb) => ({
                    label: bb.name,
                    value: bb._id,
                    ...bb,
                  }))}
                  value={this.state.selectedTo}
                  onChange={(e) => this.onChangeText("selectedTo", e)}
                  error={this.state.error.selectedTo}
                  required
                />
              ) : (
                <Input
                  label={language[this.props.defaultLanguage].destination}
                  value={this.props.to?.name || this.props.allowedBloodBankName}
                  disabled
                />
              )}
            </div>
            <div className="col-md-12">
              <Separator title="Requestor Details" />
            </div>
            <div className="col-md-4">
              <Input
                label="Name"
                value={this.props.requestedByAccount?.name || this.props.requestingDoctorName || "-"}
                disabled
              />
            </div>
            <div className="col-md-4">
              <Input
                label="Phone Number"
                value={this.props.requestedByAccount?.phone || this.props.requestingDoctorContacts || "-"}
                disabled
              />
            </div>
            <div className="col-md-4">
              <Input
                label="Email"
                value={this.props.requestedByAccount?.email || this.props.requestingDoctorEmail || "-"}
                disabled
              />
            </div>
            {console.log(this.state.products)}
            {this.state.requestedProducts?.length > 0 && (
              <div className="col-md-12" style={{ marginBottom: "1rem" }}>
                <table className="table table-sm table-bordered">
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th>Volume (ml)</th>
                      <th>Packages</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.requestedProducts.map((p, i) => (
                      <tr key={i}>
                        <td>{p.label || p.name}</td>
                        <td>{p.volume != null && p.volume !== "" ? `${p.volume} ml` : "-"}</td>
                        <td>{p.numberOfPackages || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
        <div className="modal-footer">
          <Button
            text={language[this.props.defaultLanguage].submit}
            onPress={this.onSubmit.bind(this)}
            isSubmitting={this.state.isSubmitting}
            disabled={this.state.requestedProducts.length === 0}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(ForwardRequest);
